import { CreateIndividualCustomerRequestDto } from '@/api/generated';
import {
  Address,
  addressTranslation,
  CustomerStatusOptionsTranslation,
  customerStatusOptionsTranslation,
  FlagOptionsTranslation,
  flagOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type CustomersIndividualCreateTranslation = {
  announcement: {
    distinguishingLabel: string;
  };
  button: {
    cancel: string;
    save: string;
  };
  form: Form & {
    address: Address;
    button: {
      checkNip: string;
    };
    flagOption: FlagOptionsTranslation;
    statusOption: CustomerStatusOptionsTranslation;
  };
  titleAdd: string;
  titleEdit: string;
};

type Form = Record<
  keyof Omit<CreateIndividualCustomerRequestDto, 'address' | 'firstContact'>,
  string
>;

export const customersIndividualCreateTranslation: CustomersIndividualCreateTranslation = {
  announcement: {
    distinguishingLabel:
      'Dodano pole "Wyróżnik". Przy konflikcie nazw klientów indywidualnych pozwala ono dopisać frazę, która odróżni klientów od siebie i umożliwi zapis.',
  },
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  form: {
    address: addressTranslation,
    button: {
      checkNip: 'Pobierz dane',
    },
    distinguishingLabel: 'Wyróżnik',
    flag: 'Flaga',
    flagOption: flagOptionsTranslation,
    name: 'Nazwa',
    nip: 'Numer NIP',
    status: 'Status',
    statusOption: customerStatusOptionsTranslation,
  },
  titleAdd: 'Dodaj klienta indywidualnego',
  titleEdit: 'Edycja klienta indywidualnego',
};
